<template>
    <div class="Daftar">
            <v-card width="500" class="mx-auto mt-9">
                <v-card-title>Daftar HID</v-card-title>
                <v-card-text>
                    <v-text-field 
                    label="HID" 
                    prepend-icon="mdi-biohazard"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="success">Daftar</v-btn>
                </v-card-actions>
            </v-card>
    </div>
</template>
<script>

export default {
    name: 'Daftar',
    data() {
        return {
            showPassword:false
        }
    },
    setup() {
        
    },
}
</script>